module.exports = __webpack_public_path__ + "static/img/icon75.c573c3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon75.png
// module id = luUJ
// module chunks = 0